import { combineReducers } from 'redux';
import state               from './reducers_state';
import config              from './reducers_config';
import data                from './reducers_data';

export default combineReducers({
    state,
    config,
    data
});